"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/PhoneWithTelematics.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PhoneWithTelematics = function PhoneWithTelematics(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 104.66 216.46"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Phone with Telematics Icon"), _react2.default.createElement("g", {
    className: "phone_with_signal",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "phone",
    d: "M96.89,50.11H7.77A7.79,7.79,0,0,0,0,57.88V208.69a7.79,7.79,0,0,0,7.77,7.77H96.89a7.79,7.79,0,0,0,7.77-7.77V57.88A7.79,7.79,0,0,0,96.89,50.11Zm-55,6.3H62.76a1.06,1.06,0,0,1,0,2.13H41.9A1.06,1.06,0,0,1,41.9,56.42ZM52.33,211.84a8.52,8.52,0,1,1,8.52-8.52A8.52,8.52,0,0,1,52.33,211.84Zm44.36-27a6.3,6.3,0,0,1-6.28,6.28H12.93a5,5,0,0,1-5-5v-117a6.3,6.3,0,0,1,6.28-6.28H90.41a6.3,6.3,0,0,1,6.28,6.28V184.85Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "telematic_lines",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M78.11,40.06a2,2,0,0,1-1.41-.59,34.53,34.53,0,0,0-48.78-.15A2,2,0,0,1,25.1,36.5a38.52,38.52,0,0,1,54.42.17A2,2,0,0,1,78.11,40.06Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M87.35,31.16a1.82,1.82,0,0,1-1.3-.54,47.42,47.42,0,0,0-33.71-14.1H52.19A47.42,47.42,0,0,0,18.55,30.41,1.83,1.83,0,0,1,16,27.82a51.06,51.06,0,0,1,36.22-15h0.16A51.06,51.06,0,0,1,88.65,28,1.83,1.83,0,0,1,87.35,31.16Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M95.64,21.7a1.82,1.82,0,0,1-1.3-.54,59.49,59.49,0,0,0-84-.26,1.83,1.83,0,0,1-2.58-2.59,63.15,63.15,0,0,1,89.2.27A1.83,1.83,0,0,1,95.64,21.7Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: undefined
  }))));
};
exports.default = PhoneWithTelematics;